<section
    class="tw-bg-[#F8F9FE] tw-py-10 tw-px-[25px] md:tw-px-[30px] xl:tw-px-0"
>
    <div class="tw-max-w-[1280px] tw-mx-auto tw-items-center">
        <h2
            class="!tw-text-[22px] md:!tw-text-[28px] tw-w-full tw-text-[#0F3172] !tw-font-bold"
        >
            {{ "DIGITAL_SERVICES.DIGI_SERVICE_AVAILABLE" | translate }}
        </h2>
        <p class="!tw-text-[#1A202C] !tw-text-[14px] !tw-mb-[30px]">
            {{ "DIGITAL_SERVICES.DISCOVER_INSURANCE" | translate }}
        </p>

        <div
            class="tw-flex tw-flex-col md:tw-flex-row tw-mb-5 md:tw-mb-10 tw-gap-2"
        >
            <div
                class="tw-h-[56px] tw-flex tw-flex-1 tw-content-center tw-gap-3 tw-ring-1 tw-ring-inset tw-ring-gray-300 tw-rounded-2xl tw-p-[18px] tw-bg-transparent"
            >
                <mat-icon fontIcon="search" class="tw-text-[#4B6EEC]" />
                <input
                    class="tw-flex-1 tw-font-semibold tw-bg-transparent"
                    [(ngModel)]="searchText"
                    (input)="onSearch()"
                    placeholder="{{
                        'DIGITAL_SERVICES.SEARCH_FOR_ANY_KEYWORDS' | translate
                    }}"
                />
            </div>
        </div>

        <!-- Search Results -->
        <div
            class="tw-text-2xl tw-font-semibold tw-pb-3"
            *ngIf="searchText?.trim() || digiServiceData.length == 0"
        >
            <div
                class="tw-text-base tw-font-semibold"
                [ngClass]="
                    digiServiceData.length == 0
                        ? ' tw-text-center tw-text-[#003A70]'
                        : 'tw-text-gray-600'
                "
            >
                {{
                    searchText?.trim()
                        ? selectedLanguage === "en"
                            ? resultCountText
                            : resultCountTextBM
                        : ("DIGITAL_SERVICES.NOT_RESULTS_FOUND" | translate)
                }}
            </div>
        </div>

        <div
            class="tw-hidden md:tw-grid tw-grid-cols-1 md:tw-grid-cols-3 lg:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-4"
        >
            <div
                [attr.ga-event-id]="getSlug(data)"
                [attr.ga-event-category]="'Digital Services Button'"
                [attr.ga-event-label]="
                    data?.en?.digProductName + ' Button Click'
                "
                [attr.ga-track]="'track'"
                class="tw-w-full tw-max-w-[285px] tw-mx-auto tw-rounded-2xl tw-flex tw-flex-col tw-overflow-hidden tw-cursor-pointer"
                *ngFor="let data of digiServiceData | slice: 0 : displayCount"
                (click)="redirectPartner(data, data?.partnershipUrl)"
            >
                <div
                    class="tw-p-4 tw-bg-white tw-w-full tw-flex-1 tw-flex tw-items-center tw-justify-center tw-min-h-[212px] tw-pointer-events-none"
                >
                    <img
                        class="tw-mx-auto tw-w-full tw-pointer-events-none"
                        [src]="getImageUrl(data?.partnershipImageUrl)"
                        alt="Partner Image"
                    />
                </div>
                <div
                    class="tw-bg-[linear-gradient(179.68deg,_rgba(198,_198,_198,_0)_3.29%,_#E5E5E5_63.2%)] tw-p-4 tw-w-full tw-flex-1 tw-pointer-events-none"
                >
                    <h5
                        class="!tw-text-[#002D86] !tw-font-bold !tw-text-[16px] !tw-pointer-events-none"
                    >
                        {{ getPartnerData(data)?.digProductName }}
                    </h5>
                    <p
                        class="!tw-text-[#2B2B2B] !tw-text-[13px] !tw-h-[90px] !tw-pointer-events-none"
                    >
                        {{
                            getPartnerData(data)?.digShortDescription?.length >
                            180
                                ? getPartnerData(
                                      data
                                  )?.digShortDescription?.slice(0, 180) + "..."
                                : getPartnerData(data)?.digShortDescription
                        }}
                    </p>
                    <a
                        class="!tw-text-[#2B2B2B] !tw-text-[13px] tw-font-semibold tw-pointer-events-none"
                        alt="Image description"
                        target="_blank"
                        >{{ getPartnerData(data)?.cta }}</a
                    >
                </div>
            </div>
        </div>

        <!-- show more partner cards -->
        <div
            class="tw-hidden tw-text-center tw-mt-4 md:tw-flex tw-justify-center"
            *ngIf="digiServiceData.length > initialCount"
        >
            <button
                *ngIf="displayCount < digiServiceData.length"
                class="tw-bg-transparent tw-text-[#003A70] tw-border tw-border-[#003A70] tw-rounded-full tw-py-3 tw-px-6 tw-flex tw-items-center tw-gap-2"
                (click)="showMore()"
            >
                {{ "SHOW_MORE" | translate }}
                <mat-icon class="tw-text-[#003A70]"
                    >keyboard_arrow_down</mat-icon
                >
            </button>
        </div>

        <div
            class="tw-block md:tw-hidden tw-w-full tw-relative tw-max-w-[360px] tw-mx-auto"
        >
            <ngx-slick-carousel
                class="carousel what-new"
                [config]="slideConfig"
            >
                <div
                    ngxSlickItem
                    *ngFor="
                        let data of digiServiceData | slice: 0 : displayCount
                    "
                    class="slide"
                >
                    <div
                        [attr.ga-event-id]="getSlug(data)"
                        [att.ga-event-category]="'Digital Services Button'"
                        [attr.ga-event-label]="
                            data?.en?.digProductName + ' Button Click'
                        "
                        [attr.ga-track]="'track'"
                        class="tw-w-full tw-max-w-[285px] tw-h-[437px] tw-mx-auto tw-rounded-2xl tw-flex tw-flex-col tw-overflow-hidden tw-cursor-pointer"
                        (click)="redirectPartner(data, data?.partnershipUrl)"
                    >
                        <div
                            class="tw-p-4 tw-bg-white tw-w-full tw-flex-1 tw-flex tw-items-center tw-justify-center tw-min-h-[212px] tw-pointer-events-none"
                        >
                            <img
                                class="tw-mx-auto tw-w-full tw-pointer-events-none"
                                [src]="getImageUrl(data?.partnershipImageUrl)"
                                alt="Partner Image"
                            />
                        </div>
                        <div
                            class="tw-bg-[linear-gradient(179.68deg,_rgba(198,_198,_198,_0)_3.29%,_#E5E5E5_63.2%)] tw-p-4 tw-w-full tw-flex-1 tw-pointer-events-none"
                        >
                            <h5
                                class="!tw-text-[#002D86] !tw-font-bold !tw-text-[16px] tw-pointer-events-none"
                            >
                                {{ getPartnerData(data)?.digProductName }}
                            </h5>
                            <p
                                class="!tw-text-[#2B2B2B] !tw-text-[13px] !tw-h-[90px] tw-pointer-events-none"
                            >
                                {{
                                    getPartnerData(data)?.digShortDescription
                                        .length > 180
                                        ? getPartnerData(
                                              data
                                          )?.digShortDescription.slice(0, 180) +
                                          "..."
                                        : getPartnerData(data)
                                              ?.digShortDescription
                                }}
                            </p>
                            <a
                                class="!tw-text-[#2B2B2B] !tw-text-[13px] tw-font-semibold tw-pointer-events-none"
                                alt="Image description"
                                target="_blank"
                                >{{ getPartnerData(data)?.cta }}</a
                            >
                        </div>
                    </div>
                </div>
            </ngx-slick-carousel>
        </div>
    </div>
</section>
